// Arabic word list
export const ARABIC_WORDS = [
    'وكيل', 'أمازون', 'ملاك', 'القطب الجنوبي', 'تفاحة', 'ذراع', 'أطلانتس', 'أستراليا', 'الأزتك', 'ظهر',
    'كرة', 'فرقة', 'بنك', 'شريط', 'نباح', 'خفاش', 'شاطئ', 'دب', 'ضربة', 'سرير', 'بكين', 'جرس',
    'حزام', 'برلين', 'برمودا', 'طائر', 'كتلة', 'لوحة', 'صاعقة', 'قنبلة', 'رابطة', 'انفجار', 'حذاء',
    'زجاجة', 'قوس', 'صندوق', 'جسر', 'فرشاة', 'دولار', 'جاموس', 'خطأ', 'بوق', 'زر', 'عجل',
    'كندا', 'قبعة', 'عاصمة', 'سيارة', 'بطاقة', 'جزر', 'كازينو', 'طاقم', 'قط', 'خلية', 'قنطور',
    'مركز', 'كرسي', 'تغيير', 'تهمة', 'فحص', 'صدر', 'فرخ', 'الصين', 'شوكولاتة', 'كنيسة',
    'دائرة', 'جرف', 'عباءة', 'نادي', 'رمز', 'برد', 'كوميدي', 'حاسوب', 'حفلة', 'قائد',
    'عقد', 'طباخ', 'نحاس', 'قطن', 'محكمة', 'غطاء', 'رافعة', 'تحطم', 'صرصور', 'صليب',
    'تاج', 'دورة', 'تشيكي', 'رقص', 'تاريخ', 'يوم', 'موت', 'سطح', 'درجة', 'ماس', 'نرد',
    'ديناصور', 'مرض', 'طبيب', 'كلب', 'مسودة', 'تنين', 'فستان', 'تدريب', 'قطرة', 'بطة',
    'قزم', 'نسر', 'مصر', 'محرك', 'إنجلترا', 'أوروبا', 'عين', 'وجه', 'عادل', 'سقوط',
    'مروحة', 'سياج', 'حقل', 'مقاتل', 'شكل', 'ملف', 'فيلم', 'نار', 'سمك', 'ناي',
    'ذبابة', 'قدم', 'قوة', 'غابة', 'شوكة', 'فرنسا', 'لعبة', 'غاز', 'عبقري', 'ألمانيا',
    'شبح', 'عملاق', 'زجاج', 'قفاز', 'ذهب', 'نعمة', 'عشب', 'اليونان', 'أخضر', 'أرض',
    'لحم', 'يد', 'صقر', 'رأس', 'قلب', 'هليكوبتر', 'هيمالايا', 'حفرة', 'هوليوود', 'عسل',
    'غطاء رأس', 'خطاف', 'قرن', 'حصان', 'حدوة', 'مستشفى', 'فندق', 'ثلج', 'آيس كريم', 'الهند',
    'حديد', 'عاج', 'جاك', 'مربى', 'طائرة نفاثة', 'المشتري', 'كنغر', 'كاتشب', 'مفتاح', 'طفل',
    'ملك', 'كيوي', 'سكين', 'فارس', 'مختبر', 'حضن', 'ليزر', 'محامي', 'رصاص', 'ليمون',
    'حياة', 'ضوء', 'ليموزين', 'خط', 'رابط', 'أسد', 'قمامة', 'لوخ نيس', 'قفل', 'سجل',
    'لندن', 'حظ', 'بريد', 'ماموث', 'قيقب', 'رخام', 'مارس', 'كتلة', 'مباراة', 'زئبق',
    'المكسيك', 'مجهر', 'مليونير', 'منجم', 'نعناع', 'صاروخ', 'نموذج', 'خلد', 'قمر', 'موسكو',
    'جبل', 'فأر', 'فم', 'طين', 'مومياء', 'مسمار', 'إبرة', 'شبكة', 'نيويورك', 'ليل',
    'نينجا', 'ملاحظة', 'رواية', 'ممرضة', 'جوز', 'أخطبوط', 'زيت', 'زيتون', 'أوليمبوس', 'أوبرا',
    'برتقال', 'عضو', 'نخلة', 'مقلاة', 'بنطال', 'ورق', 'مظلة', 'حديقة', 'جزء', 'تمرير',
    'عجينة', 'بطريق', 'فينيق', 'بيانو', 'فطيرة', 'طيار', 'دبوس', 'أنبوب', 'قرصان', 'مسدس',
    'حفرة', 'ملعب', 'بيتزا', 'طائرة', 'بلاستيك', 'طبق', 'خلد الماء', 'لعب', 'مؤامرة', 'نقطة',
    'سم', 'عمود', 'شرطة', 'مسبح', 'ميناء', 'بريد', 'جنيه', 'صحافة', 'أميرة', 'قرع',
    'تلميذ', 'هرم', 'ملكة', 'أرنب', 'مضرب', 'شعاع', 'ثورة', 'خاتم', 'روبن', 'روبوت',
    'صخرة', 'روما', 'جذر', 'وردة', 'روليت', 'دائري', 'صف', 'مسطرة', 'قمر صناعي', 'زحل',
    'مقياس', 'مدرسة', 'عالم', 'عقرب', 'شاشة', 'غواص', 'فقمة', 'خادم', 'ظل',
    'شكسبير', 'قرش', 'سفينة', 'حذاء', 'متجر', 'طلقة', 'مغسلة', 'ناطحة سحاب', 'انزلاق', 'رخوة',
    'طقطقة', 'ثلج', 'رجل ثلج', 'جورب', 'جندي', 'روح', 'صوت', 'فضاء', 'تعويذة', 'عنكبوت',
    'مسمار', 'عمود فقري', 'بقعة', 'ربيع', 'جاسوس', 'مربع', 'ملعب', 'عصا', 'نجمة', 'دولة',
    'عصا', 'مخزون', 'قش', 'جدول', 'إضراب', 'خيط', 'غواصة', 'بدلة', 'بطل خارق', 'تأرجح',
    'مفتاح', 'طاولة', 'لوح', 'علامة', 'ذيل', 'صنبور', 'معلم', 'تلسكوب', 'معبد', 'مسرح',
    'لص', 'إبهام', 'قراد', 'ربطة عنق', 'وقت', 'طوكيو', 'سن', 'شعلة', 'برج', 'مسار',
    'قطار', 'مثلث', 'رحلة', 'شاحنة', 'جذع', 'أنبوب', 'تركيا', 'حفار قبور', 'وحيد القرن', 'مكنسة',
    'شاحنة', 'طبيب بيطري', 'استيقاظ', 'جدار', 'حرب', 'غسالة', 'واشنطن', 'ساعة', 'ماء', 'موجة',
    'شمع', 'شبكة', 'بئر', 'حوت', 'سوط', 'ريح', 'ساحرة', 'دودة', 'فناء'
];

// English word list
export const ENGLISH_WORDS = [
    'AGENT', 'AMAZON', 'ANGEL', 'ANTARCTICA', 'APPLE', 'ARM', 'ATLANTIS', 'AUSTRALIA', 'AZTEC', 'BACK',
    'BALL', 'BAND', 'BANK', 'BAR', 'BARK', 'BAT', 'BEACH', 'BEAR', 'BEAT', 'BED', 'BEIJING', 'BELL',
    'BELT', 'BERLIN', 'BERMUDA', 'BIRD', 'BLOCK', 'BOARD', 'BOLT', 'BOMB', 'BOND', 'BOOM', 'BOOT',
    'BOTTLE', 'BOW', 'BOX', 'BRIDGE', 'BRUSH', 'BUCK', 'BUFFALO', 'BUG', 'BUGLE', 'BUTTON', 'CALF',
    'CANADA', 'CAP', 'CAPITAL', 'CAR', 'CARD', 'CARROT', 'CASINO', 'CAST', 'CAT', 'CELL', 'CENTAUR',
    'CENTER', 'CHAIR', 'CHANGE', 'CHARGE', 'CHECK', 'CHEST', 'CHICK', 'CHINA', 'CHOCOLATE', 'CHURCH',
    'CIRCLE', 'CLIFF', 'CLOAK', 'CLUB', 'CODE', 'COLD', 'COMIC', 'COMPUTER', 'CONCERT', 'CONDUCTOR',
    'CONTRACT', 'COOK', 'COPPER', 'COTTON', 'COURT', 'COVER', 'CRANE', 'CRASH', 'CRICKET', 'CROSS',
    'CROWN', 'CYCLE', 'CZECH', 'DANCE', 'DATE', 'DAY', 'DEATH', 'DECK', 'DEGREE', 'DIAMOND', 'DICE',
    'DINOSAUR', 'DISEASE', 'DOCTOR', 'DOG', 'DRAFT', 'DRAGON', 'DRESS', 'DRILL', 'DROP', 'DUCK',
    'DWARF', 'EAGLE', 'EGYPT', 'ENGINE', 'ENGLAND', 'EUROPE', 'EYE', 'FACE', 'FAIR', 'FALL',
    'FAN', 'FENCE', 'FIELD', 'FIGHTER', 'FIGURE', 'FILE', 'FILM', 'FIRE', 'FISH', 'FLUTE',
    'FLY', 'FOOT', 'FORCE', 'FOREST', 'FORK', 'FRANCE', 'GAME', 'GAS', 'GENIUS', 'GERMANY',
    'GHOST', 'GIANT', 'GLASS', 'GLOVE', 'GOLD', 'GRACE', 'GRASS', 'GREECE', 'GREEN', 'GROUND',
    'HAM', 'HAND', 'HAWK', 'HEAD', 'HEART', 'HELICOPTER', 'HIMALAYA', 'HOLE', 'HOLLYWOOD', 'HONEY',
    'HOOD', 'HOOK', 'HORN', 'HORSE', 'HORSESHOE', 'HOSPITAL', 'HOTEL', 'ICE', 'ICE CREAM', 'INDIA',
    'IRON', 'IVORY', 'JACK', 'JAM', 'JET', 'JUPITER', 'KANGAROO', 'KETCHUP', 'KEY', 'KID',
    'KING', 'KIWI', 'KNIFE', 'KNIGHT', 'LAB', 'LAP', 'LASER', 'LAWYER', 'LEAD', 'LEMON',
    'LIFE', 'LIGHT', 'LIMOUSINE', 'LINE', 'LINK', 'LION', 'LITTER', 'LOCH NESS', 'LOCK', 'LOG',
    'LONDON', 'LUCK', 'MAIL', 'MAMMOTH', 'MAPLE', 'MARBLE', 'MARS', 'MASS', 'MATCH', 'MERCURY',
    'MEXICO', 'MICROSCOPE', 'MILLIONAIRE', 'MINE', 'MINT', 'MISSILE', 'MODEL', 'MOLE', 'MOON', 'MOSCOW',
    'MOUNT', 'MOUSE', 'MOUTH', 'MUD', 'MUMMY', 'NAIL', 'NEEDLE', 'NET', 'NEW YORK', 'NIGHT',
    'NINJA', 'NOTE', 'NOVEL', 'NURSE', 'NUT', 'OCTOPUS', 'OIL', 'OLIVE', 'OLYMPUS', 'OPERA',
    'ORANGE', 'ORGAN', 'PALM', 'PAN', 'PANTS', 'PAPER', 'PARACHUTE', 'PARK', 'PART', 'PASS',
    'PASTE', 'PENGUIN', 'PHOENIX', 'PIANO', 'PIE', 'PILOT', 'PIN', 'PIPE', 'PIRATE', 'PISTOL',
    'PIT', 'PITCH', 'PIZZA', 'PLANE', 'PLASTIC', 'PLATE', 'PLATYPUS', 'PLAY', 'PLOT', 'POINT',
    'POISON', 'POLE', 'POLICE', 'POOL', 'PORT', 'POST', 'POUND', 'PRESS', 'PRINCESS', 'PUMPKIN',
    'PUPIL', 'PYRAMID', 'QUEEN', 'RABBIT', 'RACKET', 'RAY', 'REVOLUTION', 'RING', 'ROBIN', 'ROBOT',
    'ROCK', 'ROME', 'ROOT', 'ROSE', 'ROULETTE', 'ROUND', 'ROW', 'RULER', 'SATELLITE', 'SATURN',
    'SCALE', 'SCHOOL', 'SCIENTIST', 'SCORPION', 'SCREEN', 'SCUBA DIVER', 'SEAL', 'SERVER', 'SHADOW',
    'SHAKESPEARE', 'SHARK', 'SHIP', 'SHOE', 'SHOP', 'SHOT', 'SINK', 'SKYSCRAPER', 'SLIP', 'SLUG',
    'SNAP', 'SNOW', 'SNOWMAN', 'SOCK', 'SOLDIER', 'SOUL', 'SOUND', 'SPACE', 'SPELL', 'SPIDER',
    'SPIKE', 'SPINE', 'SPOT', 'SPRING', 'SPY', 'SQUARE', 'STADIUM', 'STAFF', 'STAR', 'STATE',
    'STICK', 'STOCK', 'STRAW', 'STREAM', 'STRIKE', 'STRING', 'SUB', 'SUIT', 'SUPERHERO', 'SWING',
    'SWITCH', 'TABLE', 'TABLET', 'TAG', 'TAIL', 'TAP', 'TEACHER', 'TELESCOPE', 'TEMPLE', 'THEATER',
    'THIEF', 'THUMB', 'TICK', 'TIE', 'TIME', 'TOKYO', 'TOOTH', 'TORCH', 'TOWER', 'TRACK',
    'TRAIN', 'TRIANGLE', 'TRIP', 'TRUCK', 'TRUNK', 'TUBE', 'TURKEY', 'UNDERTAKER', 'UNICORN', 'VACUUM',
    'VAN', 'VET', 'WAKE', 'WALL', 'WAR', 'WASHER', 'WASHINGTON', 'WATCH', 'WATER', 'WAVE',
    'WAX', 'WEB', 'WELL', 'WHALE', 'WHIP', 'WIND', 'WITCH', 'WORM', 'YARD'
];

// Lebanese word list (Lebanese dialect)
export const LEBANESE_WORDS = [
    'بيت', 'بيتزا', 'صبّاط', 'تلج', 'مي', 'راس', 'إيد', 'تم', 'عين', 'ضهر',
    'كرة', 'فار', 'قطة', 'كلب', 'ولد', 'بنت', 'ريّس', 'بار', 'كار', 'دراجة',
    'شارع', 'بيت', 'سطح', 'حيط', 'باب', 'شباك', 'طاولة', 'كرسي', 'سرير', 'فراش',
    'مطبخ', 'حمام', 'صالون', 'غرفة', 'بلكونة', 'درج', 'مصعد', 'كراج', 'حديقة', 'حاكورة',
    'مطعم', 'كافيه', 'مول', 'دكانة', 'صيدلية', 'مستشفى', 'مدرسة', 'جامعة', 'مكتب', 'شركة',
    'تاكسي', 'باص', 'سرفيس', 'موتور', 'شاحنة', 'فان', 'جيب', 'لوري', 'كراج', 'محطة',
    'بحر', 'جبل', 'نهر', 'وادي', 'غابة', 'صحرا', 'شاطي', 'مرفأ', 'ميناء', 'طريق',
    'ماما', 'بابا', 'تيتة', 'جدو', 'خالتو', 'عمو', 'ابن عم', 'بنت عم', 'خالة', 'عمة',
    'حبيبي', 'حبيبتي', 'صديق', 'رفيق', 'جار', 'ضيف', 'صاحب', 'شريك', 'زميل', 'أستاز',
    'دكتور', 'مهندس', 'محامي', 'أستاذ', 'معلمة', 'ممرضة', 'شرطي', 'جندي', 'طيار', 'سائق',
    'طباخ', 'نادل', 'عامل', 'خياط', 'حلاق', 'كهربائي', 'نجار', 'حداد', 'ميكانيكي', 'حارس',
    'أكل', 'شرب', 'رز', 'خبز', 'لحمة', 'دجاج', 'سمك', 'جبنة', 'لبنة', 'بيض',
    'حليب', 'زبدة', 'زيت', 'برتقان', 'تفاح', 'موز', 'عنب', 'فراولة', 'كرز', 'مشمش',
    'خضار', 'بندورة', 'خيار', 'خس', 'جزر', 'بصل', 'ثوم', 'بقدونس', 'نعنع', 'زعتر',
    'كبة', 'تبولة', 'فتوش', 'حمص', 'فول', 'ورق عنب', 'محشي', 'منقوشة', 'عجين', 'كعك',
    'قهوة', 'شاي', 'عصير', 'مي', 'بيرة', 'عرق', 'نبيذ', 'كوكا', 'بيبسي', 'فانتا',
    'موبايل', 'تلفون', 'تلفزيون', 'راديو', 'كمبيوتر', 'انترنت', 'واي فاي', 'فيسبوك', 'واتساب', 'انستغرام',
    'ديسكو', 'كازينو', 'سينما', 'مسرح', 'حفلة', 'عرس', 'زفة', 'دبكة', 'أغنية', 'موسيقى',
    'كرة قدم', 'باسكت', 'تنس', 'سباحة', 'ملعب', 'فريق', 'مباراة', 'هدف', 'فوز', 'خسارة',
    'نادي', 'كلاب', 'بار', 'ديسكو', 'رقص', 'غناء', 'عزف', 'طبلة', 'عود', 'بيانو',
    'مدرسة', 'صف', 'طالب', 'أستاذ', 'كتاب', 'دفتر', 'قلم', 'ممحاة', 'مسطرة', 'شنطة',
    'دولار', 'ليرة', 'يورو', 'ذهب', 'فضة', 'مصاري', 'فلوس', 'حساب', 'مصرف', 'صراف',
    'عيد', 'ميلاد', 'كريسماس', 'رأس السنة', 'فصح', 'أضحى', 'فطر', 'مولد', 'ذكرى', 'مناسبة',
    'مطر', 'ثلج', 'شمس', 'قمر', 'نجوم', 'سحاب', 'رعد', 'برق', 'ريح', 'هوا',
    'صيف', 'شتي', 'ربيع', 'خريف', 'حر', 'برد', 'دفا', 'رطوبة', 'جفاف', 'مطر',
    'لبنان', 'بيروت', 'طرابلس', 'صيدا', 'صور', 'زحلة', 'بعلبك', 'جونية', 'عاليه', 'برمانا'
];

// Language configurations
export interface LanguageSet {
    id: string;
    name: string;
    words: string[];
}

export const LANGUAGE_SETS: LanguageSet[] = [
    {
        id: 'arabic',
        name: 'عربي (Arabic Words)',
        words: ARABIC_WORDS
    },
    {
        id: 'english',
        name: 'English Words',
        words: ENGLISH_WORDS
    },
    // {
    //     id: 'lebanese',
    //     name: 'لبناني (Lebanese Words)',
    //     words: LEBANESE_WORDS
    // }
];

// Default to Arabic for backward compatibility
export const WORD_LIST = ARABIC_WORDS;

// Base 64 characters (URL-safe: alphanumeric + hyphen + underscore)
export const BASE64_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_';
